export default __webpack_public_path__ + "static/media/slide-5.2b7c65fd.png";